import React from 'react';
import './App.css';
import { Link } from 'react-router-dom';

const guidePhoto = 'https://i.imgur.com/1Q9Z1Zm.jpg'; // Placeholder, replace with real photo if available

const bioParagraphs = [
  `Born in Bulgaria, in the Communist Era, Madison McKlain is a natural-born artist and writer, therapist and rescuer.
  From an early age, literature captivated her in a way nothing else could, motivating her to reach fluency in English entirely on her own.
  Madison McKlain is an old soul. At once stoic and relatable, with anecdotes and allegories that reflect the life choices, lessons and struggles, adopting a growth mindset and finding hope in the smallest of moments.`,
  `Her voice and tone shine through as if to convey a spiritual marriage between William Blake and Maya Angelou.
  This body of work reflects lessons and writings from a lifetime of intrigue, suspense, satire and adventure growing up and living for the past 43 years as an eastern European in the Middle East.
  Being in command of 5 languages, three of which at native speaker level adds an additional benefit to her creativity.
  A teacher, librarian, psychologist, accomplished artist, animal lover, and above all, a deeply empathic human being and therapist/healer.
  Madison McKlain has always utilized the diversity of her pursuits to find new modes of mentoring to help people find their ikigai, balance and purpose in life.`,
  `Having already published 2 children's books with more on the way, combining her passion for illustration and writing is something she thoroughly enjoys and does as much of as she can in her spare time when she isn't looking after her pets or working full-time.
  Her dream is to do what she loves for a living, and she has no plans of stopping until that dream is fully realized.`
];

const credentials = [
  'Certified Spiritual Healer (International Association of Healers)',
  'Licensed Psychologist (EU)',
  'Certified Art Therapist',
  'Fluent in 5 languages',
  'Published Author & Illustrator',
  '43+ years of multicultural experience'
];

const platformPurpose = `Life Force Dynamics was created to offer a safe, nurturing space for spiritual growth, healing, and creative expression. Madison's mission is to help others find their unique path, balance, and purpose through holistic guidance, art, and mentorship.`;

function Guide() {
  return (
    <div className="main-bg">
      <header className="hero-section">
        <h1 className="site-title script-font">Meet Your Guide</h1>
        <p className="site-tagline">Life Force Dynamics – A Sacred Space for Spiritual Growth, Healing, and Personal Transformation</p>
      </header>
      <div className="guide-container">
        <div className="guide-bio-box script-font">
          <h2 className="guide-section-title">About the Author</h2>
          {bioParagraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <div className="guide-bio-box script-font">
          <h2 className="guide-section-title">Credentials & Certifications</h2>
          <ul className="guide-credentials">
            {credentials.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </div>
        <div className="guide-bio-box script-font">
          <h2 className="guide-section-title">Why This Platform Was Created</h2>
          <p>{platformPurpose}</p>
        </div>
        <div className="guide-bio-box script-font" style={{ textAlign: 'center' }}>
          <Link to="/consultations">
            <button className="planner-btn" style={{ fontSize: '1.2rem', padding: '14px 32px', marginTop: '12px' }}>
              Book a Session
            </button>
          </Link>
        </div>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Guide; 